import {useCallback, useRef, useState} from 'react';
import IntegrationListView from './list';
import IntegrationCreateOrUpdateView from './form';
import {useIntegrations} from './queries';
import {Integration} from 'src/core/data/api/Integration';

export type ViewType = 'list' | 'create' | 'edit';

const IntegrationContainer = () => {
  const {data: integrations, isFetching} = useIntegrations();

  const selectedIntegrationOnViewChange = useRef<Integration>();

  const [activeView, setActiveView] = useState<ViewType>('list');

  const setSelectedIntegrationOnViewChange = (data?: Integration) => {
    selectedIntegrationOnViewChange.current = data;
  };

  const onViewChange = useCallback(
    (viewName: ViewType, integration?: Integration) => {
      setSelectedIntegrationOnViewChange(integration);
      setActiveView(viewName);
    },
    [],
  );

  const views = {
    list: <IntegrationListView integrations={integrations} loading={isFetching} onViewChange={onViewChange} />,
    create: <IntegrationCreateOrUpdateView onViewChange={onViewChange} />,
    edit: <IntegrationCreateOrUpdateView selectedIntegration={selectedIntegrationOnViewChange.current} onViewChange={onViewChange} />,
  };

  return views[activeView];
};

export default IntegrationContainer;
